import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  localData: any;
  paymentUrl: any;
  constructor(private readonly http: HttpClient, private readonly store: Store<any>) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data.authReducer;
        this.paymentUrl =
          data.authReducer.businessDetails?.settings_data?.DIGITAL_ORDERING_DOMAIN;
      });
  }

  paymentStatus(data) {
    return this.http.post<any>(
      `${this.paymentUrl}/businesses/${this.localData?.businessDetails?.id}/payment_status`,
      data
    );
  }

  paymentStatusPaymongoPaynamics(data) {
    console.log(data, 'Params')
    return this.http.post<any>(
      `${this.paymentUrl}/businesses/${this.localData?.businessDetails?.id}/get_online_payment_status`,
      data
    );
  }

  payment(page) {
    let params = new HttpParams();
Object.keys(page).forEach(key => {
  params = params.set(key, page[key]);
});
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.businessDetails?.id}/fetch_payment_months`,{params}
    );
  }
  fetchPayementData(fromDate, todate,serachDes) {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.businessDetails?.id}/probase_payment?fromDate=${fromDate}&toDate=${todate}&searchDes=${serachDes}`
    );
  }
  getPaymentReportEmail(formData){
  const selectedKeys = ['fromDate', 'toDate', 'searchDes','fileType','sendAsEmail','toSend'];
  let params = new HttpParams();
  selectedKeys.forEach(key => {
    if (formData[key] !== undefined && formData[key] !== null) {
      params = params.set(key, formData[key]);
    }
  });
  const formBody = {
    "subject": formData['subject'],
    "body": Array.isArray(formData['body'])?formData['body']?.[0]:formData['body']
  }
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.businessDetails?.id}/payment_report`,formBody,{params}
    );
  }
  getPaymentReport(formData: { [key: string]: any }): Observable<HttpResponse<Blob>> {
    const selectedKeys = ['fromDate', 'toDate', 'searchDes','fileType','sendAsEmail','toSend'];
  let params = new HttpParams();
  selectedKeys.forEach(key => {
    if (formData[key] !== undefined && formData[key] !== null) {
      params = params.set(key, formData[key]);
    }
  });
  return this.http.post(
    `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.businessDetails?.id}/payment_report`,{},
    {
      responseType: 'blob' as const,
      observe: 'response' as const,
      params
    }
  );
}
}
